import { useApiRead } from "source/shared/SessionApiResource"

export function useHouseholdFinder(id) {
  return useApiRead(
    `/people/v2/directory_households/${id}?include=directory_people,directory_people.emails,directory_people.addresses,directory_people.phone_numbers`,
  )
}
